<template>
    <div>
        <app-header></app-header>        
        <div class="grid-x grid-padding-x pad-top">
            <div class="cell small-12 medium-8 medium-offset-2">
                <h1>
                    Preview your design
                    <router-link
                        to="/checkout/basket"
                        class="float-right button squared with-icon">
                        Back to basket
                        <i class="material-icons">shopping_basket</i>
                    </router-link>
                </h1>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 medium-6 medium-offset-2">
                <ul
                    class="design-nav marg-left-none">
                    <li
                        v-on:click="selectSide('Front')"
                        v-bind:class="{ active : selectedSide === 'Front' }">
                        Front
                    </li>
                    <li
                        v-on:click="selectSide('Back')"
                        v-bind:class="{ active : selectedSide === 'Back' }">
                        Back
                    </li>
                    <li
                        v-on:click="selectSide('Left')"
                        v-bind:class="{ active : selectedSide === 'Left' }">
                        Left
                    </li>
                    <li
                        v-on:click="selectSide('Right')"
                        v-bind:class="{ active : selectedSide === 'Right' }">
                        Right
                    </li>
                </ul>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top pad-bottom">
            <div class="cell small-12 medium-8 medium-offset-2">
                <label>Change Garment</label>
                <select
                    v-model="chosenGarment"
                    v-on:change="backgroundChosen = true">
                    <option
                        v-for="(garment, index) in garments"
                        v-bind:key="index"
                        v-bind:value="index">
                        {{ garment.product_code }} {{ garment.name}} {{ garment.colour_code }}
                    </option>
                </select>    
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top pad-bottom--xl">
            <div class="cell small-12 medium-8 medium-offset-2">
                <div
                    class="easel"
                    v-bind:class="`type_${selectedCategory}_${selectedSide}`">
                    <div
                        class="easel-inner"
                        v-bind:style="{ backgroundImage: 'url(' + selectedDesignGarmentColour + ')' }">
                        <canvas id="c"></canvas>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import fabric from 'fabric';
import axios from '../../axios';

export default {
    name: 'PreviewDesign',
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
    computed: {
        basket() {
            return this.$store.getters.basketItems;
        },
        garments() {
            const gs = [];
            const g = {};
            for (let i = 0; i < this.basket.length; i += 1) {
                g.product_code = this.basket[i].product_code;
                g.colour_code = this.basket[i].colour_code;
                g.name = this.basket[i].name;
                gs.push(g);
            }
            return gs;
        },
        selectedDesignGarmentColour() {
            let sdgc = false;
            if (this.garments[0]) {
                let side = '';
                if (this.selectedSide === 'Front') {
                    side = 'FRONT';
                } else if (this.selectedSide === 'Back') {
                    side = 'BACK';
                } else if (this.selectedSide === 'Left') {
                    side = 'LEFT';
                } else if (this.selectedSide === 'Right') {
                    side = 'RIGHT';
                }
                let productCode = '';
                let colourCode = '';
                if (this.backgroundChosen === false) {
                    productCode = this.garments[this.chosenGarment].product_code;
                    colourCode = this.garments[this.chosenGarment].colour_code;
                } else {
                    productCode = this.backgroundChosen.productCode;
                    colourCode = this.backgroundChosen.colourCode;
                }
                sdgc = `https://runsmart-dropship.s3.eu-west-2.amazonaws.com/garments/pencarrie_images/${productCode}+${colourCode}+${side}.jpg`;
            }
            return sdgc;
        },
    },
    data() {
        return {
            back: {},
            backgroundChosen: false,
            canvas: {},
            chosenGarment: 0,
            front: {},
            left: {},
            right: {},
            selectedCategory: 1,
            selectedSide: 'Front',
        };
    },
    methods: {
        getDesign() {
            const postData = {};
            postData.id = this.$route.params.id;
            axios.post('/Designs/getPreview.json', postData)
            .then((response) => {
                for (let i = 0; i < response.data.designGroup.length; i += 1) {
                    if (response.data.designGroup[i].side === 'Front') {
                        this.front = response.data.designGroup[i];
                    }
                    if (response.data.designGroup[i].side === 'Back') {
                        this.back = response.data.designGroup[i];
                    }
                    if (response.data.designGroup[i].side === 'Left') {
                        this.left = response.data.designGroup[i];
                    }
                    if (response.data.designGroup[i].side === 'Right') {
                        this.right = response.data.designGroup[i];
                    }
                }
                this.renderPreview();
            });
        },
        renderPreview() {
            let design = {};
            if (this.selectedSide === 'Front') {
                design = this.front;
            }
            if (this.selectedSide === 'Back') {
                design = this.back;
            }
            if (this.selectedSide === 'Left') {
                design = this.left;
            }
            if (this.selectedSide === 'Right') {
                design = this.right;
            }
            const json = design.canvas_string;
            this.canvas = new fabric.fabric.Canvas('c');
            this.canvas.setDimensions({ width: 650, height: 800 });
            this.canvas.loadFromJSON(
                json,
                this.canvas.renderAll.bind(this.canvas),
            );
        },
        selectSide(side) {
            this.selectedSide = side;
            this.renderPreview();
        },
    },
    mounted() {
        this.getDesign();
    },
};
</script>


// WEBPACK FOOTER //
// src/components/CheckOut/Preview.vue